// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"02d39bb6","453":"d995cca6","455":"2fc26051","977":"cd5743ad"}[chunkId] + ".chunk.js";
};